import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if the app is running in PWA mode
 * Checks if the app is running in standalone mode (installed as PWA)
 * @returns {boolean} isPWA - true when running in PWA mode, false in browser
 */
const usePWA = () => {
    // Initialize state with the actual PWA detection (synchronous)
    const [isPWA, setIsPWA] = useState(() => {
        const isStandalone = globalThis.matchMedia('(display-mode: standalone)').matches;
        const isIOSStandalone = globalThis.navigator.standalone === true;
        const isFullscreen = globalThis.matchMedia('(display-mode: fullscreen)').matches;
        const result = isStandalone || isIOSStandalone || isFullscreen;

        console.log('[usePWA] Initial state calculation:', {
            isStandalone,
            isIOSStandalone,
            isFullscreen,
            result
        });

        return result;
    });

    useEffect(() => {
        console.log('[usePWA] Hook initialized');
        const checkPWAMode = () => {
            // Check if running in standalone mode (PWA)
            const isStandalone = globalThis.matchMedia('(display-mode: standalone)').matches;

            // Check for iOS standalone mode
            const isIOSStandalone = globalThis.navigator.standalone === true;

            // Check for fullscreen mode (some PWAs use this)
            const isFullscreen = globalThis.matchMedia('(display-mode: fullscreen)').matches;

            const result = isStandalone || isIOSStandalone || isFullscreen;

            console.log('[usePWA] checkPWAMode:', {
                isStandalone,
                isIOSStandalone,
                isFullscreen,
                result
            });

            setIsPWA(result);
        };

        // Check for any changes (in case display mode changes dynamically)

        // Listen for changes in display mode
        const standaloneQuery = globalThis.matchMedia('(display-mode: standalone)');
        const fullscreenQuery = globalThis.matchMedia('(display-mode: fullscreen)');

        // Add event listeners for display mode changes
        if (standaloneQuery.addEventListener) {
            standaloneQuery.addEventListener('change', checkPWAMode);
            fullscreenQuery.addEventListener('change', checkPWAMode);
        }

        // Cleanup listeners on unmount
        return () => {
            if (standaloneQuery.removeEventListener) {
                standaloneQuery.removeEventListener('change', checkPWAMode);
                fullscreenQuery.removeEventListener('change', checkPWAMode);
            }
        };
    }, []);

    console.log('[usePWA] Returning isPWA:', isPWA);
    return isPWA;
};

export default usePWA;
